// helpers.js
import { API_PASSWORD } from './config';


// helpers.js
export const getSubdomain = () => {
    const hostname = window.location.hostname;
    if (hostname.includes("localhost")) {
      return hostname.split(".")[0] || "localhost";
    }
    const parts = hostname.split(".");
    return parts.length > 2 && parts[0] !== "www" ? parts[0] : null;
  };
  
  export const getToken = () => {
    const token = localStorage.getItem("token");
    console.log("🔑 التوكن المستخرج من localStorage:", token);
    if (!token) {
        console.warn("⚠️ لا يوجد توكن مخزن في localStorage، تحقق من تسجيل الدخول.");
        return null;
    }
    return token;
};

// export const fetchWithAuth = async (url, options = {}, isFormData = false, requireToken = true) => {
//   const token = getToken(); 
//   const headers = {
//     ...(requireToken && token ? { "Authorization": `Bearer ${token}` } : {}), // ✅ تجنب إرسال Authorization إذا لم يكن هناك توكن
//     ...(!isFormData && { "Content-Type": "application/json" }),
//     ...options.headers,
//   };

//   console.log("📡 إرسال طلب إلى:", url);
//   console.log("🔑 التوكن في الهيدر:", headers.Authorization);



//   if (!isFormData && (options.method === "POST" || options.method === "PUT")) {
//     options.body = JSON.stringify({
//       ...JSON.parse(options.body || "{}"),
//       api_password: API_PASSWORD,
//     });
//   } else {
//     url += url.includes("?") ? "&" : "?";
//     url += `api_password=${API_PASSWORD}`;
//   }

//   return fetch(url, { ...options, headers });
// };

// helpers.js
export const fetchWithAuth = async (
  url,
  options = {},
  isFormData = false,
  requireToken = true
) => {
  const token = getToken();

  const headers = {
    ...(requireToken && token ? { Authorization: `Bearer ${token}` } : {}),
    ...(!isFormData && { "Content-Type": "application/json" }),
    ...options.headers,
  };

  // إضافة api_password
  if (!isFormData && (options.method === "POST" || options.method === "PUT")) {
    options.body = JSON.stringify({
      ...JSON.parse(options.body || "{}"),
      api_password: API_PASSWORD,
    });
  } else {
    url += url.includes("?") ? "&" : "?";
    url += `api_password=${API_PASSWORD}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  // 🔥🔥🔥 الجزء الأهم
  if (response.status === 401) {
    console.warn("🚨 Token Expired - Logout");

    localStorage.clear();

    // يفضل location.replace عشان يمنع الرجوع Back
    window.location.replace("/login");

    // نوقف أي تنفيذ بعد كدا
    throw new Error("Unauthorized");
  }

  // 🔁 لو الباك بيرجع رسالة بدل 401
  if (response.ok) {
    const clone = response.clone();
    try {
      const data = await clone.json();
      if (data?.message === "برجاء تسجيل الخروج") {
        console.warn("🚨 Backend requested logout");

        localStorage.clear();
        window.location.replace("/login");

        throw new Error("Token expired");
      }
    } catch {
      // response مش JSON
    }
  }

  return response;
};
